import React from "react";
import { TextField } from "@mui/material";
import { usePlacesWidget } from "react-google-autocomplete";

/**
 * Component for Google Auto Complete Input
 * @param {object} props
 * @param {function} props.onChange - Handle the change event of Input
 * @param {function} props.onPlaceChange - Handle place change event
 * @component
 */
function PlaceAutoComplete(props) {
  const {
    onChange = () => null,
    placeholder = "",
    onPlaceChange = () => null,
    disable = false,
    country = "ae", // null = worldwide (candidates can live abroad)
    ...rest
  } = props;

  const { ref: materialRef } = usePlacesWidget({
    apiKey: "AIzaSyA3brzWUkPZefbmCIXng1Zd2X1SyetcSa4",
    onPlaceSelected: (place) => {
      const obj = {
        location: place?.formatted_address || "",
        lat: place?.geometry?.location?.lat(),
        lng: place?.geometry?.location?.lng(),
      };
      onChange(obj);
      console.log("PlaceAutoComplete ~ place", place);
    },
    options: {
      types: ["geocode"],
      ...(country ? { componentRestrictions: { country } } : {}),
    },
  });

  return (
    <TextField
      inputRef={materialRef}
      placeholder={placeholder}
      disabled={disable}
      {...rest}
    />
  );
}

export default PlaceAutoComplete;
